import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ReportsFilter, ParamFilter, MultiLocationFilter } from '../../filters';
import FilterSelector from '../../filters/filters-selector';

class FilterContainer extends Component {
  render() {
    const {
      filters, params,
    } = this.props;

    const filterComponents = filters.map(filter => (<FilterSelector key={filter} filterName={filter} />));

    const paramFilters = params?.map(param => (<ParamFilter key={param.name} param={param} />));

    return (
      <div className="filter-details">
        <MultiLocationFilter />
        <ReportsFilter />
        {filterComponents}
        {paramFilters}
      </div>
    );
  }
}

FilterContainer.propTypes = {
  filters: PropTypes.array.isRequired,
  params: PropTypes.array,
};

FilterContainer.defaultProps = {
  params: [],
};

export default FilterContainer;
